import { useMediaQuery } from "react-responsive";
export function useIsLargerThanIpadResolution() {
    return useMediaQuery({ query: `(min-width: 811px)` });
}
